import { render, staticRenderFns } from "./filevideo.vue?vue&type=template&id=776540fc&scoped=true"
import script from "./filevideo.vue?vue&type=script&lang=js"
export * from "./filevideo.vue?vue&type=script&lang=js"
import style0 from "./filevideo.vue?vue&type=style&index=0&id=776540fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776540fc",
  null
  
)

export default component.exports